import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IUserModel, IUser } from '../models/user.model';
import { apiParameters } from 'src/app/configs/api.params';
import { StorageService } from './storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private token: string;
  private user: any;
  public apiEndPoint = apiParameters.url;
  // public apiParam = '/users/7';

  constructor(
    private httpClient: HttpClient,
    private storage: StorageService
  ) {}

  get myToken(): string {
    return this.token;
  }
  set myToken(helper: string) {
    this.token = helper;
  }

  // Get loged in user
  getLoggedInUser(): IUserModel {
    return (
      this.storage.getSessionObject('user') ||
      this.storage.getLocalObject('user')
    );
  }

  updateCurrentUser(user: IUser) {
    const currentUser = this.getLoggedInUser();
    const token = currentUser.token;
    sessionStorage.setItem('currentUser', JSON.stringify({ user, token }));
  }

  get(): Observable<IUser> {
    const currentUser = this.getLoggedInUser();
    const token = currentUser.token;
    const userId = currentUser.user.id;
    const httpOptions = {
      headers: new HttpHeaders({}),
    };
    const body: any = {};
    return this.httpClient
      .get(apiParameters.url + '/users/' + userId, httpOptions)
      .pipe(
        map((res: IUser) => {
          return res;
        })
      );
  }

  createUser(companyId: string, body): Observable<any> {
    return this.httpClient.post(
      `${apiParameters.url}/companies/${companyId}/users`,
      body
    );
  }

  editUser(companyId: string, userId: string, body): Observable<any> {
    return this.httpClient.patch(
      `${apiParameters.url}/companies/${companyId}/users/${userId}`,
      body
    );
  }

  getById(id: string): Observable<IUser> {
    return this.httpClient.get(apiParameters.url + '/users/' + id).pipe(
      map((res: IUser) => {
        return res;
      })
    );
  }

  getCompanyUsers(companyId: string): Observable<any> {
    return this.httpClient
      .get(`${apiParameters.url}/companies/${companyId}/users`)
      .pipe(
        map((res: any[]) => {
          res.sort((a, b) => {
            return (
              (new Date(b.lastTimeOnline) as any) -
              (new Date(a.lastTimeOnline) as any)
            );
          });
          return res;
        })
      );
  }

  getCompanyWorkers(companyId: string, name: string, email:string): Observable<any> {
    let searchParams = new HttpParams();

    if (name && name !== '') {
      searchParams = searchParams.append('name', name);
    }
    if (email && email !== '') {
      searchParams = searchParams.append('email', email);
    }
    
    const httpOptions = {
      params: searchParams,
    };

    return this.httpClient
      .get(`${apiParameters.url}/companies/${companyId}/workers`, httpOptions)
      .pipe(
        map((res: any[]) => {
          res.sort((a, b) => {
            return (
              (new Date(b.lastTimeOnline) as any) -
              (new Date(a.lastTimeOnline) as any)
            );
          });
          return res;
        })
      );
  }

  getAllFilialsAdmins(companyId: string, name: string, email:string): Observable<any> {
    let searchParams = new HttpParams();

    if (name && name !== '') {
      searchParams = searchParams.append('name', name);
    }
    if (email && email !== '') {
      searchParams = searchParams.append('email', email);
    }

    const httpOptions = {
      params: searchParams,
    };

    return this.httpClient
      .get(`${apiParameters.url}/companies/${companyId}/filial-admins`, httpOptions)
      .pipe(
        map((res: any[]) => {
          res.sort((a, b) => {
            return (
              (new Date(b.lastTimeOnline) as any) -
              (new Date(a.lastTimeOnline) as any)
            );
          });
          return res;
        })
      );
  }

  getCompanyUser(companyId: string, userId: string): Observable<any> {
    return this.httpClient.get(
      `${apiParameters.url}/companies/${companyId}/users/${userId}`
    );
  }

  deleteUser(companyId: string, userId: string): Observable<any> {
    return this.httpClient.delete(
      `${apiParameters.url}/companies/${companyId}/users/${userId}`
    );
  }

  changePassword(userId: string, body): Observable<any> {
    return this.httpClient.patch(
      `${apiParameters.url}/users/${userId}/change-password`,
      body
    );
  }

  uploadProfileImage(userId: string, body): Observable<any> {
    return this.httpClient.post(
      `${apiParameters.url}/users/${userId}/profile-images`, body
    )
  }
}
